import fetch from 'auth/FetchInterceptor'

const settingsService = {}
const apiRoute = '/AdminSettings';

settingsService.getSettings = async function (query = '') {
  try {
    const res = await fetch({
      url: `${apiRoute}/get/all/admin${query}`,
      method: 'get',
    });
    return res;
  } catch (err) {
    console.log(err.response?.data || err.message, 'API Error - getAll');
    console.log(err, 'show-err');
  }
}

settingsService.edit = async function (id, data) {
  try {
    const res = await fetch({
      url: `${apiRoute}/update/admin/${id}`,
      method: 'patch',
      data: data,
    })
    return res
  } catch (err) {
    console.log(err.response?.data || err.message, 'API Error - edit');
    console.log(err, 'show-err')
  }
}

export default settingsService;